import { Component, Vue } from 'vue-property-decorator'
import GeoDirection from '@/directions/types/GeoDirection'
import CurrentLocation from '@/classes/CurrentLocation'
import axios, { AxiosResponse } from 'axios'
import { MAPBOX_PARAMS } from '@/plugins/mapbox-config'

@Component
export default class CreatesItemFromMapboxFeature extends Vue {
	private countryFromMapboxFeature(item: any): string {
		const found = (item.context || []).find((contextItem) => {
			return contextItem.id.startsWith('country')
		})
		if (found) return found.short_code
		return ''
	}

	public createItemFromMapboxFeature(item: any): GeoDirection {
		const geoDirectionLocation = new GeoDirection()

		geoDirectionLocation.geo = item.geometry
		geoDirectionLocation.icon = 'map-marker-alt'
		geoDirectionLocation.text = item.place_name
		geoDirectionLocation.color = '#000000'
		geoDirectionLocation.country = this.countryFromMapboxFeature(item)

		return geoDirectionLocation
	}

	public async parseLocationFromVesselOrGeolocation(): Promise<GeoDirection | null> {
		const location = await CurrentLocation.getCurrentLocation()

		if (!location) {
			return null
		}

		const response = (await axios.get(
			`https://api.mapbox.com/geocoding/v5/mapbox.places/${location.geo.coordinates[0]},${location.geo.coordinates[1]}.json`,
			{
				params: { ...MAPBOX_PARAMS, limit: 1 }
			}
		)) as AxiosResponse<any>

		if (!response.data.features) {
			return location
		}

		return this.createItemFromMapboxFeature(response.data.features[0])
	}
}
